import { FC } from 'react';
import { XIcon } from './XIcon';
import { cn } from './cn';
import { Button } from './Button';

export const CloseButton: FC<{ onClick: () => void; className?: string }> = ({ onClick, className }) => {
  return (
    <Button
      variant="flat"
      size="flat"
      onClick={onClick}
      className={cn('size-10 rounded-full border-2 border-black bg-white', className)}
    >
      <XIcon className="size-5" />
    </Button>
  );
};
